import styles from './PlugError.module.scss'
import React from 'react'

export const PlugError = () => {
  const isIpOrAck = process.env.REACT_APP_IS_IP_OR_ACK === 'true'

  const url = window.location.href
  const urlOrgin = new URL(url).origin

  const finsovetnik =
    urlOrgin === process.env.REACT_APP_PROD_FA_URL ||
    urlOrgin === process.env.REACT_APP_TEST_FA_URL

  return (
    <div className={styles.root} data-testid="header">
      {isIpOrAck ? null : finsovetnik ? (
        <img
          data-testid="fs-logo"
          src="/FSlogo.png"
          alt=""
          className={styles.FSlogo}
        />
      ) : (
        <img
          data-testid="default-logo"
          src="/logo.png"
          alt=""
          className={styles.logo}
        />
      )}

      <div className={styles.main} data-testid="main">
        <img
          data-testid="errorImg"
          src="/robotImg.png"
          alt="error"
          className={styles.errorImg}
        />

        <div className={styles.errorTitle} data-testid="errorTitle">
          Что то пошло не так
        </div>
        <div className={styles.errorText} data-testid="errorText">
          Форма оплаты временно недоступна. Попробуйте обновить страницу или
          вернуться позже
        </div>
      </div>
    </div>
  )
}
